import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, RepeatIcon, CheckCircleIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: 1,
    icon: DownloadIcon,
    title: 'Descarga',
    description: 'Recibes el material en tu correo inmediatamente tras la compra.'
  }, {
    number: 2,
    icon: RepeatIcon,
    title: 'Practica',
    description: 'Usas las listas con traducción espejo para entrenar tu oído y tu voz.'
  }, {
    number: 3,
    icon: CheckCircleIcon,
    title: 'Aprueba',
    description: 'Llevas tu carpeta organizada siguiendo nuestro checklist y respondes con seguridad.'
  }];
  return <section className="w-full bg-white" data-id="element-117">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-119">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-120">
            Así de Fácil Funciona
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-121">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="text-center" data-id="element-122">
                <div className="relative inline-block mb-6" data-id="element-123">
                  <div className="w-20 h-20 bg-[#1B2A4A] rounded-full flex items-center justify-center" data-id="element-124">
                    <step.icon className="w-10 h-10 text-[#C9A84C]" data-id="element-125" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-10 h-10 bg-[#C9A84C] rounded-full flex items-center justify-center font-bold text-[#1B2A4A] text-lg" data-id="element-126">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-gray-700" data-id="element-128">{step.description}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}